/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:19b95aa2-0d25-44ea-b865-50a537400e91",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_5v0xdAz3G",
    "aws_user_pools_web_client_id": "424cb9f51duukevc9b0243dpcq",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL",
        "PHONE_NUMBER"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "PHONE_NUMBER"
    ],
    "aws_appsync_graphqlEndpoint": "https://dhlmawddcvdf3eylbxgaivb6bm.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-cvxr4sthazfbdhfvdonglnpgs4",
    "aws_cloud_logic_custom": [
        {
            "name": "RESTfundraising",
            "endpoint": "https://yqvscnzzof.execute-api.us-east-2.amazonaws.com/prod",
            "region": "us-east-2"
        }
    ],
    "aws_user_files_s3_bucket": "flourish-storage181632-prod",
    "aws_user_files_s3_bucket_region": "us-east-2",
    "geo": {
        "amazon_location_service": {
            "region": "us-east-2",
            "maps": {
                "items": {
                    "mapf27315b8-prod": {
                        "style": "VectorEsriStreets"
                    }
                },
                "default": "mapf27315b8-prod"
            },
            "search_indices": {
                "items": [
                    "placeindex0a376cc2-prod"
                ],
                "default": "placeindex0a376cc2-prod"
            }
        }
    }
};


export default awsmobile;
